const displayName = 'ClassDropdown';
const dropdownPlaceholder = 'Select a class';

export { displayName, dropdownPlaceholder };
